var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon20Tm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11938 12.7627L7.83505 16.897C8.25283 16.897 8.43742 16.7116 8.67061 16.4915L10.6778 14.5972L14.8538 17.5916C15.6223 18.0031 16.1769 17.7901 16.3683 16.8991L19.1097 4.36136C19.3903 3.26924 18.6807 2.77391 17.9455 3.09786L1.84849 9.12203C0.749713 9.54977 0.756119 10.1447 1.6482 10.4098L5.77907 11.6612L15.3425 5.80541C15.7939 5.5397 16.2083 5.68255 15.8682 5.97549L8.11914 12.7625L8.11938 12.7627Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20Tm);
export default __webpack_public_path__ + "static/media/icon--20-tm.98acea1c.svg";
export { ForwardRef as ReactComponent };